const sendSlackMessage = (
  from = 'Public Alerts',
  icon_emoji = ':bell:',
  text = ' ',
  channel = '#system-events',
  error
) => {
  let slackMessage = {
    username: from,
    icon_emoji,
    text,
    channel
  }

  const useBeta =
    window.location.hostname.includes('beta') ||
    window.location.hostname === 'localhost'

  if (useBeta) {
    slackMessage.channel = channel + '-beta'
  }

  if (error) {
    if (error.response && error.response.data) {
      const { errorCode, raw, safe, statusCode } = error.response.data
      const errorMessage = `\n*Error:* \nstatusCode: ${statusCode} \nraw: ${raw} \nsafe: ${
        Array.isArray(safe) ? safe.join(', ') : safe
      } \nerrorCode: \`${errorCode}\``
      slackMessage.text = text + errorMessage
    } else {
      slackMessage.text =
        text +
        `\n*Error:*\n \`\`\`${JSON.stringify(
          error,
          Object.getOwnPropertyNames(error)
        )} \`\`\` `
    }
  }

  fetch(
    'https://hooks.slack.com/services/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',
    {
      method: 'POST',
      body: JSON.stringify(slackMessage)
    }
  ).catch((error) => {
    console.error('Error:', error)
  })
}

export default sendSlackMessage
